import * as React from 'react';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import TxpDataRow from 'txp-data/lib/schema/viewSchema/TxpDataRow';
import { dataRows } from './dataRows';

let classNames = require('classnames');

export interface SummaryProps {
    lines: TxpDataRow[];
    txpStyle: TxpStyle;
    entityIcon?: string;
    flightSummaryLine?: TxpDataRow;
    isEditableEntity?: boolean;
}

/**
 *  This componet displays the summary lines in mail, peek and form TXP cards.
 *  Styles are applied to four summary lines by passing custom styles in txpStyle
 *  from corresponding wrappers.
 */
function Summary(props: SummaryProps) {
    let { entityIcon, lines, txpStyle, flightSummaryLine, isEditableEntity } = props;

    let summaryLines = lines.map((txpDataRow, index) => {
        if (txpDataRow) {
            return dataRows(index, txpStyle, txpDataRow.text);
        } else {
            return null;
        }
    });

    return (
        <div className={classNames(txpStyle.cardSummaryLines, 'allowTextSelection')}>
            <div
                className={isEditableEntity ? txpStyle.editableSummaryLabel : txpStyle.summaryLabel}
                title={lines[0].text}>
                {entityIcon && <Icon iconName={entityIcon} />}
                {summaryLines[0]}
            </div>
            {summaryLines.slice(1)}
            {flightSummaryLine && (
                <div className={txpStyle.summaryLabel}>
                    {flightSummaryLine.icon && (
                        <Icon iconName={flightSummaryLine.icon} className={txpStyle.iconStyle} />
                    )}
                    <div>
                        {flightSummaryLine.label && (
                            <label className={txpStyle.labelStyle}>{flightSummaryLine.label}</label>
                        )}
                        <span>{flightSummaryLine.text}</span>
                    </div>
                </div>
            )}
        </div>
    );
}
export default Summary;
